import * as actionTypes from './actionTypes'

export const subjectTest = (state = {
  isFetching: false,
  isSubmiting: false,
  error: null,
}, action) => {
  switch (action.type) {
    case actionTypes.SUBJ_TEST_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.SUBJ_TEST_RECEIVE:
      return {
        ...state,
        ...action.data,
        isFetching: false,
      };
    case actionTypes.SUBJ_TEST_ERROR:
      return {
        ...state,
        didInvalidate: false,
        error: action.error,
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/subjectTest/reducers.js